import type { FlowId, FlowSummary } from '@interfaces/IFlowView';
import {
  CompassIcon,
  GitCompareIcon,
  PackageIcon,
  ShieldIcon,
  WrenchIcon,
} from '@utils/icons';
import styles from './FlowSelector.module.css';

type IFlowSelectorProps = {
  title: string;
  meta: string;
  countLabel: string;
  healthLabel: string;
  flows: FlowSummary[];
  activeId: FlowId;
  onSelect: (id: FlowId) => void;
};

function FlowGlyph({ id }: { id: FlowId }) {
  switch (id) {
    case 'mep':         return <WrenchIcon size={18} />;
    case 'procurement': return <PackageIcon size={18} />;
    case 'qa':          return <ShieldIcon size={18} />;
    case 'design':      return <CompassIcon size={18} />;
  }
}

export function FlowSelector({ title, meta, countLabel, healthLabel, flows, activeId, onSelect }: IFlowSelectorProps) {
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div className={styles.heading}>
          <GitCompareIcon size={14} />
          <span className={styles.title}>{title}</span>
          <span className={styles.meta}>· {meta}</span>
        </div>
        <span className={styles.count}>{countLabel}</span>
      </header>

      <div className={styles.grid}>
        {flows.map((f) => (
          <button
            type="button"
            key={f.id}
            className={styles.tile}
            data-active={f.id === activeId}
            onClick={() => onSelect(f.id)}
          >
            <span className={styles.tileSelectedDot} aria-hidden />
            <span className={styles.tileHead}>
              <span className={styles.glyphBox}>
                <FlowGlyph id={f.id} />
              </span>
              <span className={styles.tileTitle}>{f.title}</span>
            </span>
            <p className={styles.tileStages}>{f.stages}</p>
            <div className={styles.tileFoot}>
              <span className={styles.healthLabel}>{healthLabel}</span>
              <span className={styles.bar} aria-hidden>
                <span className={styles.barFill} style={{ width: `${f.health}%` }} />
              </span>
              <span className={styles.healthValue}>{f.health}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
